import { Divider, Stack } from "@mui/material";
import AffirmPolicy from "@/components/common/paymentPlans/affirmPolicy";
import {
  PoweredByMoxie,
  PoweredByMoxieProps,
} from "@/components/common/powerByMoxie/powerByMoxie";

// temporary component, should be removed when the new online booking flow is implemented
export default function PoweredByMoxieWithAffirm({
  medspaSlug,
  affirmEnabled,
}: PoweredByMoxieProps & {
  affirmEnabled: boolean;
}) {
  return (
    <Stack>
      {affirmEnabled && (
        <Stack sx={{ mt: 2 }}>
          <AffirmPolicy />
          <Divider />
        </Stack>
      )}
      <PoweredByMoxie medspaSlug={medspaSlug as string} />
    </Stack>
  );
}
